<template>
  <select class="form-control" name="parent_web_menu_item" id="parent_web_menu_item" @change="onChange($event)">
    <option value="0">Selecciona un elemento de un menú</option>
    <option :value="menuItemId" :selected="selectedValue == menuItemId" v-for="(menuItemName, menuItemId) in options">{{ menuItemName }}</option>
  </select>
</template>

<script>
import axios from "axios";
import Url from '@/core/Url.js'

export default {
  name: 'menu-item-selector',
  emits: ['update','error'],
  props: {
    selectedValue : {},
    menu : {},
  },
  watch: {
    selectedValues: function(newVal, oldVal) {
      this.value  = newVal;
    },
  },
  data() {
    return {
      value: '',
      options: {},
      placeholder: 'Selecciona un elemento de un menú'
    }
  },
  methods: {
    buildOptions: function (items) {
      let options = {};
      let option_key;
      for (let key in items) {
        option_key = items[key]['id'];
        options[option_key] = items[key]['name'];
      }
      return options;
    },
    initMenuItems () {
      axios
          .get(Url.getMenuItemsListUrl())
          .then(response => {
            if (response.data.result) {
              this.options = this.buildOptions(response.data.data);
            } else {
              this.emitError();
            }
          }).catch(error => {
        this.emitError(error);
      })
    },
    emitError () {
      this.$emit('error', "Se ha producido un error al consultar los items de menús.");
    },
    onChange (event) {
      this.value = event.target.value;
      this.$emit('update', this.value);
    },
  },
  created () {
    this.initMenuItems ();
  }
}
</script>
